import { ShaderModule, UniformTypes } from '@luma.gl/shadertools';

// Caution: order matters !!!
const uniformBlock = `\
uniform feVectorLineUniforms {
    uniform int rangeType;
    uniform float range;
} feVectorLine;
`;

export type VectorLineLayerUniforms = {
    rangeType: number;
    range: number;
};

export const vectorLineLayerUniforms = {
    name: 'feVectorLine',
    vs: uniformBlock,
    uniformTypes: {
        rangeType: 'i32',
        range: 'f32'
    } as const satisfies UniformTypes<Required<VectorLineLayerUniforms>>
} as const satisfies ShaderModule<VectorLineLayerUniforms>;
